const actionPrefix = "timelineRange";
const CHANGE_DATE_FROM = `${actionPrefix}CHANGE_DATE_FROM`;
const CHANGE_DATE_TO = `${actionPrefix}CHANGE_DATE_TO`;

export const actionTypes = {
  CHANGE_DATE_FROM,
  CHANGE_DATE_TO
};

const changeDateFrom = from => {
  return {
    type: CHANGE_DATE_FROM,
    from
  };
};

const changeDateTo = to => {
  return {
    type: CHANGE_DATE_TO,
    to
  };
};

export default {
  changeDateFrom,
  changeDateTo
};
